<div class="flyout-source-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="!expandedTab || expandedTab === 'source'" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <img class="header-icon" src="/assets/img/icons_fl/source.svg" width="32px" height="32px" />
        <span>{{ "flyout.source.title" | translate }}</span>
      </mat-expansion-panel-header>
      @if (source) {
        <div class="expansion-panel-row values">
          <div class="label">
            <span>{{ "flyout.source.title" | translate }}:</span>
          </div>
          <div class="value">
            <span>{{ source }}</span>
          </div>
        </div>
      }
      @if (utmSource) {
        <div class="expansion-panel-row values">
          <div class="label">
            <span>{{ "flyout.source.utm-source" | translate }}:</span>
          </div>
          <div class="value">
            <span>{{ utmSource }}</span>
          </div>
        </div>
      }
      @if (utmName) {
        <div class="expansion-panel-row values">
          <div class="label">
            <span>{{ "flyout.source.utm-name" | translate }}:</span>
          </div>
          <div class="value">
            <span>{{ utmName }}</span>
          </div>
        </div>
      }
      @if (utmMedium) {
        <div class="expansion-panel-row values">
          <div class="label">
            <span>{{ "flyout.source.utm-medium" | translate }}:</span>
          </div>
          <div class="value">
            <span>{{ utmMedium }}</span>
          </div>
        </div>
      }
      @if (referer) {
        <div class="expansion-panel-row values">
          <div class="label">
            <span>{{ "flyout.source.referer" | translate }}:</span>
          </div>
          <div class="value">
            <span>{{ referer }}</span>
          </div>
        </div>
      }
      @if (refererType) {
        <div class="expansion-panel-row values">
          <div class="label">
            <span>{{ "flyout.source.referer-type" | translate }}:</span>
          </div>
          <div class="value">
            <span>{{ refererType }}</span>
          </div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
